"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiGateway = void 0;
var tslib_1 = require("tslib");
require("reflect-metadata");
var inversify_1 = require("inversify");
// TODO: Replace eventually with: https://github.com/Desygner/api-gateway
var ApiGateway = exports.ApiGateway = /** @class */ (function () {
    function ApiGateway() {
        this.credentials = null;
    }
    ApiGateway.prototype.buildAuthorizationHeader = function (token) {
        return typeof token === 'string'
            ? "Basic ".concat(token)
            : "".concat(token.type, " ").concat(token.token);
    };
    ApiGateway.prototype.configure = function (baseUrl, token, company) {
        this.credentials = {
            baseUrl: baseUrl,
            token: this.buildAuthorizationHeader(token),
            company: company,
        };
    };
    Object.defineProperty(ApiGateway.prototype, "authorization", {
        get: function () {
            if (this.credentials === null) {
                throw new Error('Credentials not set');
            }
            return this.credentials.token;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ApiGateway.prototype, "company", {
        get: function () {
            if (this.credentials === null) {
                throw new Error('Credentials not set');
            }
            return this.credentials.company;
        },
        enumerable: false,
        configurable: true
    });
    ApiGateway.prototype.getRequestHeaders = function () {
        if (this.credentials === null) {
            throw new Error('Credentials not set');
        }
        return new Headers({
            Accept: 'application/json',
            Authorization: this.authorization,
            'Content-Type': 'application/json',
        });
    };
    ApiGateway.prototype.fetch = function (method, endpoint, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var baseUrl, trimmedEndpoint, url, response, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.credentials === null) {
                            throw new Error('Credentials not set');
                        }
                        baseUrl = this.credentials.baseUrl.replace(/\/$/, '');
                        trimmedEndpoint = endpoint.replace(/^\//, '');
                        url = "".concat(baseUrl, "/").concat(trimmedEndpoint);
                        return [4 /*yield*/, fetch(url, {
                                method: method,
                                body: payload,
                                headers: this.getRequestHeaders(),
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        if (!response.json) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, response.json()];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        error_1 = _a.sent();
                        if (response.status >= 200 && response.status < 300) {
                            return [2 /*return*/, null];
                        }
                        throw new Error('Error parsing JSON');
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ApiGateway.prototype.createQueryParams = function (data) {
        if (!data) {
            return '';
        }
        var params = new URLSearchParams(data);
        return params.toString();
    };
    ApiGateway = tslib_1.__decorate([
        (0, inversify_1.injectable)(),
        tslib_1.__metadata("design:paramtypes", [])
    ], ApiGateway);
    return ApiGateway;
}());
//# sourceMappingURL=api-gateway.js.map